module.exports = __webpack_public_path__ + "static/img/logo.f95e7478.png";